// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"933ab164","453":"b4162e4d","667":"5ae29e6b"}[chunkId] + ".chunk.js";
};